(() => {
  'use strict';

  const CUSTOM_ACTION_NAME = 'Join our Facebook Group';
  const RIVO_WAY_TO_EARN_ID = '585980';

  // This asset is loaded globally, while Rivo's earning cards can render later.
  // A single delegated listener covers Rivo rerenders without rebinding handlers.
  if (window.CraftoriaRivoFacebookGroupActionInitialized) {
    return;
  }

  window.CraftoriaRivoFacebookGroupActionInitialized = true;
  window.rivoFacebookGroupLoaded = true;

  const recordCustomAction = () => {
    const rivo = window.Rivo;
    const customerId = rivo?.common?.customer?.id;
    const loyaltyProxyPath = rivo?.global_config?.proxy_paths?.loy;

    if (!customerId || !loyaltyProxyPath) {
      console.warn('[Craftoria Rewards] Facebook Group action was not recorded: Rivo customer data is unavailable.');
      return;
    }

    const proxyUrl = `${loyaltyProxyPath}/loy/customers/${encodeURIComponent(customerId)}/record_custom_action`;

    // Do not await or prevent navigation: the Facebook link keeps its normal behavior.
    // Rivo owns the server-side frequency and duplicate-award enforcement.
    fetch(proxyUrl, {
      method: 'POST',
      credentials: 'same-origin',
      keepalive: true,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        custom_action_name: CUSTOM_ACTION_NAME
      })
    })
      .then((response) => {
        if (!response.ok) {
          console.error('[Craftoria Rewards] Facebook Group action was rejected by Rivo.', response.status);
        }
      })
      .catch((error) => {
        console.error('[Craftoria Rewards] Facebook Group action could not be recorded.', error);
      });
  };

  document.addEventListener(
    'click',
    (event) => {
      const joinButton = event.target instanceof Element
        ? event.target.closest(`a.rivo-modal-button[data-way-to-earn-id="${RIVO_WAY_TO_EARN_ID}"]`)
        : null;

      // This is the unique Rivo action ID for "Join our Facebook Group".
      // Rivo's own click handler still opens the configured Facebook destination.
      if (joinButton) {
        recordCustomAction();
      }
    },
    true
  );
})();
